import React, { useState } from 'react';
import './Contact.css';
import img1 from './facebook.png';
import img2 from './instagram.png';
import img3 from './phone.png';
import img4 from './video.png';
import img5 from './waze.png';
import img6 from './website .png';
import Vcard from '../Vcard/Vcard';
import Call from '../Call-t/Call';

const ImageContainer: React.FC = () => {
    const [isListOpen1, setIsListOpen1] = useState(false);
    const [isListOpen2, setIsListOpen2] = useState(false);

    function handleToggleList(listNumber: number) {
        if (listNumber === 1) {
            setIsListOpen1(!isListOpen1);
            setIsListOpen2(false);
        } else if (listNumber === 2) {
            setIsListOpen2(!isListOpen2);
            setIsListOpen1(false);
        }
    }

    return (
        <>
            <h2 id='digital-card-title'>عيادة تعافي</h2>
            <h4>للعلاج الريفلكسولوجي</h4>
            <div className='Continar'>
                <div className='ConLine1'>
                    <a href="https://www.facebook.com/profile.php?id=61561107336387">
                        <img id='Me4' src={img1} alt="Facebook" />
                    </a>
                    <span id='Spa'>فيسبوك</span>

                    <a href="https://www.instagram.com/recovery_taafii_/">
                        <img id='Me4' src={img2} alt="Instagram" />
                    </a>
                    <span id='Spa'>انستچرام</span>
                </div>

                <div className='ConLine2'>
                    <Call />

                    <a href="https://www.youtube.com/channel/UCHuqb0zd1UiKhmGG2NhyOoA">
                        <img id='Me5' src={img4} alt="Video" />

                    </a>
                    <span id='Spa5'>يوتيوب</span>
                </div>

                <div className='ConLine4'>
                    <a href="https://maps.app.goo.gl/obABA5Jr8nTHQdgL6">
                        <img id='Me4' src={img5} alt="Waze" />
                    </a>
                    <span id='Spa'>لتصل الينا</span>

                    <a href="mailto:boulosghada@gmail.com" target="_blank" rel="noopener noreferrer">

                        <img id='Me4' src={img6} alt="Website" />
                    </a>
                    <span id='Spa'>لمراسلتنا</span>
                </div>
            </div>
            <Vcard />
            <div id='Par'>
                <p>
                    <ul>

                        <li>العلاج «الريفلكسولوجي» Reflexology او علم المنعكسات هو أسلوب علاج طبيعي بديل يقوم على النظرية أن أعضاء الجسم والأعصاب والغدد والأجزاء الأخرى من الجسم متصلة بنقاط انعكاس على القدمين، وتوجد تلك النقاط على باطن القدمين بالإضافة إلى أعلى القدمين وجوانبها.
                        </li>

                        <li> من خلال استثارة تلك النقاط باستخدام أسلوب الضغط الخفيف، ونوع من التدليك يمكنك أن تولد استجابة مباشرة وتثير التعافي في العضو في الجسم المتصل بالنقطة التي قمت بتدليكها. على سبيل المثال، من خلال تدليك المجموعة العصبية المرتبطة بالرأس (والتي توجد في الإصبع الكبير في القدم)، يمكنك أن تنشط عمليات تحقيق الشفاء من حالات الصداع.
                        </li>
                        <li>العلاج الريفلكسولوجي يساعد في الاسترخاء العام، التخفيف من اثار التعب والألم، تحسين وتقوية جهاز المناعة وتنشيط الدورة الدموية.
                            كما ويعالج مشاكل صحية عديدة متعلقة بالجهاز الهضمي، الجهاز الهيكلي والعامود الفقري ومشاكل صحية عديدة أخرى.
                        </li>


                    </ul>


                </p>
            </div>
            <div id='Lor'>
                <p>
                    <button id='Tog' onClick={() => handleToggleList(1)}>
                        {isListOpen1 ? 'اغلق' : ' من انا'}
                    </button>
                    {isListOpen1 && (
                        <ul id='open'>
                            <li>غادة بولس معالجة بالريفلكسولوجي مؤهلة من كلية ريدمان</li>
                            <li>رقم الهاتف: 0545717774</li>
                            <li>العنوان: الناصرة حي شنلر</li>
                            <li>البريد الآلكتروني:boulosghada@gmail.com</li>
                        </ul>

                    )}
                </p>
            </div>
            <div id='Lor1'>
                <p>
                    <button id='Me' onClick={() => handleToggleList(2)}>
                        {isListOpen2 ? 'اغلق' : 'لحجز دور للعلاج  '}
                    </button>
                    {isListOpen2 && (
                        <ul id='open1'>
                            <li>
                                <a href="https://wa.me/+972545717774" target="_blank" rel="noopener noreferrer">
                                    للحجز اضغط هنا
                                </a>


                            </li>


                        </ul>
                    )}
                </p>
            </div>
            <h1 id='hello'>اخبارنا في انستقرام





            </h1>

        </>
    );
};

export default ImageContainer;
